import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
    useAddLeasingOperatorMutation,
    useDeleteLeasingOperatorMutation,
    useEditLeasingOperatorMutation
} from "../../../../../redux/api/handBooksApi/leasingOperatorApi";
import { EntLeasingOperator } from "../../../../../models/handBooks/leasingOperator";

const useLeasingOperator = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addLeasingOperator] = useAddLeasingOperatorMutation();
    const [deleteLeasingOperator] = useDeleteLeasingOperatorMutation();
    const [editLeasingOperator] = useEditLeasingOperatorMutation();

    async function onAddLeasingOperator(newLeasingOperator: EntLeasingOperator): Promise<boolean> {
        try {
            let status: boolean = false;
            await addLeasingOperator(newLeasingOperator).then((response: any) => {
                if (response.error !== undefined) {

                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteLeasingOperator(leasingOperator: EntLeasingOperator) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteLeasingOperator(leasingOperator.id).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditLeasingOperator(editedLeasingOperator: EntLeasingOperator): Promise<boolean> {
        try {
            let status: boolean = false;
            await editLeasingOperator(editedLeasingOperator).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddLeasingOperator,onDeleteLeasingOperator, onEditLeasingOperator }

}
export { useLeasingOperator };

